/* eslint-disable */
const activeEnv = process.env.GATSBY_ACTIVE_ENV || process.env.NODE_ENV || "development";

export const getPasswordResetBaseURL =
  activeEnv === "production"
    ? "https://7efpy5nte8.execute-api.eu-west-1.amazonaws.com/prod"
    : "https://jhhs6d8jmb.execute-api.eu-west-1.amazonaws.com/dev";
